import { SiestaBar } from './sidebar/SiestaBar';

export function DefaultSidebar() {
  return <SiestaBar />;
}
